(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-chat"] && !Shopify.designMode) return;
  try {
    (function () {
  var footer = document.querySelector('footer');
  if (!footer || !('IntersectionObserver' in window)) return;

  var ready = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener(
          'gorgias-widget-loaded',
          resolve,
          { once: true }
        );
      });

  ready.then(function () {
    var chat = window.GorgiasChat;
    var root = document.documentElement;
    var footerVisible = false;
    var chatOpen = chat.isOpen();

    function update() {
      root.classList.toggle(
        'briller-footer-chat-hidden',
        footerVisible && !chatOpen
      );
    }

    new IntersectionObserver(function (entries) {
      footerVisible = entries[0].isIntersecting;
      update();
    }).observe(footer);

    chat.on('widget:opened', function () {
      chatOpen = true;
      update();
    });

    chat.on('widget:closed', function () {
      chatOpen = false;
      update();
    });

    footer.addEventListener('click', function (event) {
      var link = event.target.closest('a[href*="gs_open_chat"]');

      if (
        !link ||
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey
      ) return;

      event.preventDefault();
      chat.open();
    });
  }).catch(function () {
    document.documentElement.classList.remove(
      'briller-footer-chat-hidden'
    );
  });
})();
  } catch(e) { console.error(e); }
})();

})();
